export default {
  index(url = '') {
    return axios.post(
      import.meta.env.VITE_SITE_URL + '/bookkeepings/invoices/by-period' + url,
    );
  },

  indexKLA(url = '') {
    return axios.post(
      import.meta.env.VITE_SITE_URL +
      '/bookkeepings/invoices/by-period/KLA' +
      url,
    );
  },

  store(invoice) {
    return axios.post(import.meta.env.VITE_SITE_URL + '/bookkeepings/invoices', {
      invoice,
    });
  },
  show(id) {
    return axios.get(
      import.meta.env.VITE_SITE_URL + '/bookkeepings/invoices/' + id,
    );
  },
  update(invoice) {
    return axios.put(
      import.meta.env.VITE_SITE_URL + '/bookkeepings/invoices/' + invoice.id,
      { invoice },
    );
  },
  destroy(id) {
    return axios.delete(
      import.meta.env.VITE_SITE_URL + '/bookkeepings/invoices/' + id,
    );
  },
  getDictionary() {
    return axios.get(
      import.meta.env.VITE_SITE_URL + '/bookkeepings/invoices/dictionary',
    );
  },
  getInternalEvidencesForEvidence(id) {
    return axios.post(
      import.meta.env.VITE_SITE_URL + '/bookkeepings/evidences/' + id + '/internal-evidences',
    );
  },
  getInternalEvidencesByPeriod(month, year) {
    return axios.post(import.meta.env.VITE_SITE_URL + '/bookkeepings/evidences/internal-evidences/by-period', {
      params: {
        year: year,
        month: month,
      },
    });
  },
  getEvidenceTaxes({ quarter, month, year, evidencetype, pitsettlementsperiodtype }) {
    return axios.get(import.meta.env.VITE_SITE_URL + '/bookkeepings/evidences/taxes', {
      params: {
        year,
        quarter,
        month,
        evidencetype,
        pitsettlementsperiodtype,
      },
    });
  },
  indexKpirColumns() {
    return axios.get(import.meta.env.VITE_SITE_URL + '/bookkeepings/kpir/columns');
  },
  indexKpirColumnsIncome() {
    return axios.get(import.meta.env.VITE_SITE_URL + '/bookkeepings/kpir/columns/income');
  },
  indexKpirColumnsDeduction() {
    return axios.get(import.meta.env.VITE_SITE_URL + '/bookkeepings/kpir/columns/deduction');
  },
  indexRyczaltRates() {
    return axios.get(import.meta.env.VITE_SITE_URL + '/bookkeepings/ryczalt/rates');
  },
  bookAutomaticInvoice(id) {
    return axios.post(
        import.meta.env.VITE_SITE_URL + '/bookkeepings/invoices/' + id + '/book-automatic',
    );
  },
  async bookAutomaticInvoiceImmediately(id) {
    const bookResults = await axios.post(
      import.meta.env.VITE_SITE_URL + '/bookkeepings/invoices/' + id + '/book-automatic-immediately',
    );

    if (bookResults.data.error) {
      throw new Error(bookResults.data.error);
    }

    return bookResults;
  },
  getEvidence(invoiceOriginal) {
    return axios.get(
        import.meta.env.VITE_SITE_URL + '/bookkeepings/invoices/' + invoiceOriginal + '/evidence',
    );
  },
};
